import React from 'react';

import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';

import { CardModal } from 'components/card-modal';
import { useRoute } from 'hooks/navigation/use-route';
import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { useCart } from 'hooks/use-cart';
import { useMenuScroll } from 'hooks/use-menu-scroll';
import { MenuItemUnavailable } from 'pages/menu/components/menu-item-unavailable';
import { MenuProductSkeleton } from 'pages/menu/components/menu-product-skeleton';
import { ProductDetail } from 'pages/menu/components/product-detail';
import { ProductWizardProvider } from 'pages/menu/components/product-wizard';
import { useLogMenuContent } from 'pages/menu/menu-object-page/use-log-menu-content';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

// new - one menu
export const MenuProductPage = () => {
  useRumPageView('product-wizard', 'Product Wizard');
  useMenuScroll();
  const isMinimalCartUIEnabled = useFlag(LaunchDarklyFlag.ENABLE_MINIMAL_CART_UI);
  const { indexedMenu, isLoading } = useUnifiedMenuContext();

  const { pathname, params } = useRoute<{ id: string; cartIdEditing: string }>();
  const { id = '', cartIdEditing = '' } = params || {};

  const { cartEntries: legacyCartEntries } = useCart();
  const { cartEntries } = useMinimalCart();

  const menuObject = indexedMenu.find(id);
  const menuObjectType = String(menuObject?.type);

  // TODO: determine how we'll manage loading
  const { error: menuObjectError } = {
    error: null,
  };

  useLogMenuContent({
    loggedValues: {
      id,
      name: menuObject?.name?.locale ?? '',
      menuType: menuObjectType,
    },
    pathname,
  });

  // TODO: implement useHandleMenuItemInOffer
  if (isLoading) {
    return (
      <CardModal noDesktopWebMaxWidth>
        <MenuProductSkeleton type={menuObjectType} />
      </CardModal>
    );
  }

  // TODO: implement isOffer
  const isOffer = false;
  if (!menuObject || menuObjectError) {
    return <MenuItemUnavailable isOffer={isOffer} />;
  }

  const editingCartEntry = isMinimalCartUIEnabled
    ? cartEntries.find(x => x.cartId === cartIdEditing)
    : legacyCartEntries.find(x => x.cartId === cartIdEditing);

  return (
    <CardModal testID="menu-product-page" noDesktopWebMaxWidth>
      <ProductWizardProvider menuObject={menuObject} editingCartEntry={editingCartEntry}>
        <ProductDetail />
      </ProductWizardProvider>
    </CardModal>
  );
};
